import fetchApi from '../util/fetchApi';
import checkErrors from './checkErrors';

export const LookupApi = {
  async getInstitutions() {
    return checkErrors(await fetchApi.lookup.get('institutions'));
  },
  async getProducts({ institution }) {
    return checkErrors(await fetchApi.lookup.get(`products/${institution}`));
  },
  async getClientTypes() {
    return checkErrors(await fetchApi.lookup.get('client-types'));
  },
  async getRoles() {
    return checkErrors(await fetchApi.lookup.get('roles'));
  },
  async getProfiles() {
    return checkErrors(await fetchApi.lookup.get('profiles'));
  },
  async getLists() {
    return checkErrors(await fetchApi.lookup.get('lists'));
  },
  async getListItem({ itemId }) {
    return checkErrors(await fetchApi.lookup.get(`lists/${itemId}`));
  },
  async getUseMultiplesOrganizationsAndRoles() {
    return checkErrors(await fetchApi.lookup.get('useMultiplesOrganizationsAndRoles'));
  },
  async getAppOptions() {
    return checkErrors(await fetchApi.api.get('app-options'));
  },
  async getRoleUsers({ roleId }) {
    return (await checkErrors(await fetchApi.lookup.get(`role/${roleId}/users`))).data;
  },
  async getSLASetting({ ignoreCache } = {}) {
    return checkErrors(
      await fetchApi.lookup.get('sla', {
        resetCache: ignoreCache,
      })
    );
  },
  async getMetadataAttributeEnum(attribute) {
    return (await checkErrors(await fetchApi.lookup.get(`metadata/enum/${attribute}`))).data;
  },
  async getUsers({ roles, inOffice, canOwn }) {
    return checkErrors(
      await fetchApi.lookup.get('users', {
        useCache: false,
        query: {
          roles: roles ? roles.join(',') : undefined,
          inOffice,
          canOwn,
        },
      })
    );
  },
  async getOrganizationalUnits(data) {
    return checkErrors(
      await fetchApi.lookup.get('organizationalunits', {
        useCache: false,
        query: data,
      })
    );
  },
  async getParentReportRequirements({ orgUnitId }) {
    return (
      await checkErrors(
        await fetchApi.lookup.get('ocifparentrequirements', {
          query: { id: orgUnitId },
        })
      )
    ).data;
  },
  async getDistinctMetadataValues({ objectSchemaName, key }) {
    return (
      await checkErrors(
        await fetchApi.lookup.get('metadata/distinct-values', {
          query: { objectSchemaName, key },
        })
      )
    ).data;
  },
};

export default LookupApi;
